export const regions = [
  "None",
  "Asia",
  "Americas",
  "Africa",
  "Europe",
  "Oceania",
  "Antarctic",
];

export const url = `https://restcountries.com/v3.1/all`;
